import { get } from 'lodash';
import { COVERME_REFERENCE_ID } from '@trip-ux/constants';
import { ReduxStore } from './payload-types';

/**
 * Get the reference code from state or query params.
 * This is in a separate file to avoid circular dependency with reducers.ts
 */
export const getRefCode = (state: ReduxStore, queryParams: Record<string, string>): string =>
  get(state, 'userProfile.whiteLabel.referenceId') || queryParams.refCode || COVERME_REFERENCE_ID;
